/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_c8b8e65c"]'><div><div :class='["picker-demo-title"]'>order-picker:</div><cube-date-picker :min="(min)" :max="(max)" :value="(value)" :columnOrder="(columnOrder)"/></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_c8b8e65c"}'>
.picker-demo-title
  margin-bottom: 8px
.event-params,
.demo-data
  margin-top: 10px
  .key
    margin-bottom: 10px
  .value
    margin-bottom: 20px
    white-space: break-spaces
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_c8b8e65c"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_c8b8e65c"}
  /** script content **/
  require("./order-picker.mpx.js?isComponent&outputPath=components%2Forder-pickerc8b8e65c%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./order-picker.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Forder-pickerc8b8e65c%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_c8b8e65c"],
    ctorType: "component",
    outputPath: "components/order-pickerc8b8e65c/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-date-picker':getComponent(require("../../../packages/mpx-cube-ui/src/components/date-picker/index.mpx?isComponent&outputPath=components%2Findexc2f4660c%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>